<template>
  <div class="table-actions">
    <span @click="details" class="fa-stack">
      <i class="fa fa-circle-thin fa-stack-2x"></i>
      <i :class=" (!val) ? 'down' : 'up'" class="fa-caret-down fa fa-stack-1x"></i>
    </span>
    <span @click="openDetails" class="fa-stack">
      <i data-toggle="row" class="fa fa-circle-thin fa-stack-2x"></i>
      <i class="fa fa-eye fa-stack-1x"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Buttons',
  props: ['data', 'index'],
  data: function () {
    return {
      val: false,
      class: 'fa fa-caret-down'
    };
  },
  methods: {
    details: function () {
      this.getIcon();
      this.$parent.$parent.toggleChildRow(this.data.id);
    },
    openDetails: function () {
      this.$parent.$parent.$parent.rowClicked(this.data);
    },
    getIcon: function () {
      if (this.val === false) {
        this.val = true;
      } else {
        this.val = false;
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Modules/Table/TableButtons.vue